import { render, staticRenderFns } from "./TermsAndConditionsComponent.vue?vue&type=template&id=64dfa8f0&scoped=true"
import script from "./TermsAndConditionsComponent.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsComponent.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsComponent.vue?vue&type=style&index=0&id=64dfa8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dfa8f0",
  null
  
)

export default component.exports